import getDefaultMenu from '../../components/Post/menu'

function getMenu(props = {}) {
    // Kiszűrjük: edit (0), ban (2), approve (3), editor edit (6)
    // Meghagyjuk: delete (1), protection (4), removeProtection (5)
    return getDefaultMenu(props).filter((menu, index) => {
        return index === 1 || index === 4 || index === 5
    })
}

export default getMenu
